module.exports = __webpack_public_path__ + "img/1536803366.88527af0.jpg";